import React from "react";
import styled from "styled-components";
import Bg from "../assets/images/bg/matte-2_2x-removebg-preview.png"


const ContactUs = () => {
  return (
    <ContactContainer id="contact">
      <BgImg src={Bg}/>
      <ContactHeading>CONTACT US</ContactHeading>
      <ContactSubHeading>Get in Touch</ContactSubHeading>
      <ContactForm>
        <InputContainer>
          <Input name="name" type="text" placeholder="Your Name" required />
          <Input name="phoneno" type="text" placeholder="Your Phone Number" required />
        </InputContainer>
        <InputContainer>
          <Input name="email" type="text" placeholder="Your Email" required />
          <Input name="subject" type="text" placeholder="Subject" required />
        </InputContainer>
        <TextAreaContainer>
          <TextArea
            name="message"
            placeholder="Message here..."
            rows={10}
            required
          />
        </TextAreaContainer>
        <ContactButton>Send Message</ContactButton>
      </ContactForm>
    </ContactContainer>
  );
};

export default ContactUs;

const BgImg = styled.img`
  position: absolute;
  top: 15%;
  left: 25%;
  z-index: -1;
  opacity: 0.4;
  transform: scale(1.5) skewX(10deg);
`;

const ContactButton = styled.button`
  border: none;
  font-weight: bold;
  letter-spacing: 1.5px;
  font-size: 1rem;
  color: white;
  background: var(--color-red);
  padding: 1rem 3rem;
  border-radius: 3rem;
  display: grid;
  justify-self: center;
  margin-top: 2rem;
  margin-bottom: 5rem;

  &:hover {
    color: var(--color-red);
    background: white;
    outline: 2px solid var(--color-red);
  }
`;

const TextArea = styled.textarea`
  resize: none;
  background: rgba(255, 255, 255, 0.15);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  border-radius: 2rem;
  padding: 1rem;
  border: none;
  outline: none;
  color: var(--color-blue);
  font-size: 1rem;
  font-weight: bold;
  /* height: 3rem; */

  &::placeholder {
    color: var(--color-blue);
    font-weight: 100;
    font-size: 1rem;
  }

  &:focus {
    display: inline-block;
    box-shadow: 0 0 0 0.2rem var(--color-blue);
    backdrop-filter: blur(60rem);
    border-radius: 2rem;
  }
`;

const Input = styled.input`
  background: rgba(255, 255, 255, 0.15);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  border-radius: 2rem;
  height: 3rem;
  padding: 1rem;
  border: none;
  outline: none;
  color: var(--color-blue);
  font-size: 1rem;
  font-weight: bold;

  &::placeholder {
    color: var(--color-blue);
    font-weight: 100;
    font-size: 1rem;
  }

  &:focus {
    display: inline-block;
    box-shadow: 0 0 0 0.2rem var(--color-blue);
    backdrop-filter: blur(60rem);
    border-radius: 2rem;
  }
`;

const ContactForm = styled.form`
  display: grid;
  gap: 3rem;
  margin-top: 3rem;
`;
const InputContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
`;
const TextAreaContainer = styled.div`
  display: grid;
`;

const ContactSubHeading = styled.h1`
  color: var(--color-blue);
  font-weight: bolder;
  letter-spacing: 2px;
  font-size: 2.5rem;
`;

const ContactHeading = styled.h4`
  color: var(--color-red);
  font-weight: bolder;
  letter-spacing: 2px;
`;

const ContactContainer = styled.div`
  max-width: 1200px;
  margin: auto;
  margin-top: 5rem;
  position: relative;
`;
